import { camelizeKeys } from '@skytech/utils'

import type { Buyout } from '@/components/buyout/types'
import { get, post } from '@/util/auth'

const buyoutResources = {
  get: async () => {
    const buyoutData = await get<unknown>('app/buyout-details')
    const parsedData = camelizeKeys(buyoutData)

    return parsedData as Buyout
  },

  // mutations
  post: async () => post('app/buyout'),
}

export default buyoutResources
